import { type FC, Suspense } from 'react';
import classnames from 'classnames';

import { ErrorBoundary } from 'dibs-error-tools/ErrorBoundary.tsx';
import { Spinner } from 'dibs-elements/exports/Spinner.tsx';

import GetHelpRenderer from './GetHelpRenderer.tsx';
import Error from './Error.tsx';

import dibsCss from 'dibs-css';

const GetHelpEmbedded: FC = () => {
    return (
        // note: this data-tn is also used in packages/dibs-contact-1stdibs/src/OtherHelp.tsx to modify scroll position
        <Suspense
            fallback={
                <div className={classnames(dibsCss.flex, dibsCss.justifyCenter)}>
                    <Spinner />
                </div>
            }
        >
            <div data-tn="get-help-modal">
                <ErrorBoundary fallback={() => <Error />}>
                    <GetHelpRenderer />
                </ErrorBoundary>
            </div>
        </Suspense>
    );
};

export default GetHelpEmbedded;
